/* JUGO Merch PDP — variant + gallery + add-to-cart wiring.
   Works for products with 1 or 2 option dimensions.
   Reads variant JSON embedded by the section. */
(function () {
  'use strict';

  function moneyFormat(cents) {
    var n = Number(cents) / 100;
    var hasFrac = Math.round(n * 100) % 100 !== 0;
    return '$' + n.toFixed(hasFrac ? 2 : 0);
  }

  function initSection(root) {
    var sectionId = root.getAttribute('data-section-id');
    var variantScript = document.querySelector('script[data-pm-variants][id$="' + sectionId + '"]');
    if (!variantScript) return;
    var variants;
    try {
      variants = JSON.parse(variantScript.textContent.trim());
    } catch (e) {
      console.error('[Merch PDP] Failed to parse variants', e);
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    var optionInputs = root.querySelectorAll('[data-pm-option-input]');
    var variantInput = root.querySelector('[data-pm-variant-input]');
    var priceMain = root.querySelector('[data-pm-price-main]');
    var priceCompare = root.querySelector('[data-pm-price-compare]');
    var cta = root.querySelector('[data-pm-cta]');
    var ctaText = root.querySelector('[data-pm-cta-text]');
    var soldNote = root.querySelector('[data-pm-sold-note]');
    var errEl = root.querySelector('[data-pm-error]');
    var stageImg = root.querySelector('[data-pm-stage]');
    var thumbs = root.querySelectorAll('[data-pm-thumb]');
    var form = root.querySelector('#product-form-merch');

    function getSelectedOptions() {
      var picked = {};
      optionInputs.forEach(function (input) {
        if (input.checked) {
          var idx = parseInt(input.getAttribute('data-pm-option-input'), 10);
          picked[idx] = input.value;
        }
      });
      return picked;
    }

    function findVariantFor(opts) {
      return variants.find(function (v) {
        return Object.keys(opts).every(function (k) {
          var optKey = 'option' + k;
          return v[optKey] === opts[k];
        });
      });
    }

    function updateOptionLabels(opts) {
      Object.keys(opts).forEach(function (k) {
        var label = root.querySelector('[data-pm-option-value="' + k + '"]');
        if (label) label.textContent = opts[k];
      });
    }

    function refreshPillAvailability(opts) {
      // For each option, look at sibling values and mark which combos exist (and are in stock)
      var optionGroups = root.querySelectorAll('[data-pm-option-index]');
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-pm-option-index'), 10);
        var inputs = group.querySelectorAll('[data-pm-option-input]');
        inputs.forEach(function (input) {
          var probe = Object.assign({}, opts);
          probe[idx] = input.value;
          var v = findVariantFor(probe);
          var label = group.querySelector('label[for="' + input.id + '"]');
          if (!label) return;
          var unavailable = !v || !v.available;
          label.classList.toggle('is-unavailable', unavailable);
        });
      });
    }

    function setVariant(v) {
      if (!v) {
        if (variantInput) variantInput.value = '';
        if (cta) { cta.disabled = true; cta.setAttribute('aria-disabled', 'true'); }
        if (ctaText) ctaText.textContent = 'Unavailable';
        if (soldNote) soldNote.hidden = true;
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (priceMain) priceMain.textContent = moneyFormat(v.price);
      if (priceCompare) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceCompare.textContent = moneyFormat(v.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (cta) {
        cta.disabled = !v.available;
        cta.setAttribute('aria-disabled', String(!v.available));
      }
      if (ctaText) {
        ctaText.textContent = v.available
          ? 'Add to bag — ' + moneyFormat(v.price)
          : 'Sold out';
      }
      if (soldNote) soldNote.hidden = v.available;

      if (v.featured_image && v.featured_image.src && stageImg) {
        swapStage(v.featured_image.src);
      }
      if (history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    function swapStage(srcRaw) {
      if (!stageImg) return;
      var src = srcRaw.startsWith('//') ? 'https:' + srcRaw : srcRaw;
      if (stageImg.src === src) return;
      stageImg.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = function () {
        stageImg.src = src;
        stageImg.removeAttribute('srcset');
        requestAnimationFrame(function () { stageImg.classList.remove('is-swapping'); });
      };
      pre.src = src;
    }

    function onOptionChange() {
      var opts = getSelectedOptions();
      updateOptionLabels(opts);
      refreshPillAvailability(opts);
      var v = findVariantFor(opts);
      setVariant(v);
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', onOptionChange);
    });

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        var full = btn.getAttribute('data-src-full');
        var srcset = btn.getAttribute('data-src-srcset');
        if (stageImg && full) {
          stageImg.classList.add('is-swapping');
          var pre = new Image();
          pre.onload = function () {
            stageImg.src = full;
            if (srcset) stageImg.setAttribute('srcset', srcset);
            var alt = btn.getAttribute('data-alt');
            if (alt) stageImg.alt = alt;
            requestAnimationFrame(function () { stageImg.classList.remove('is-swapping'); });
          };
          pre.src = full;
        }
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var vid = variantInput && variantInput.value;
        if (!vid) {
          e.preventDefault();
          if (errEl) { errEl.textContent = 'Please choose your options.'; errEl.hidden = false; }
          return;
        }
        e.preventDefault();
        if (errEl) errEl.hidden = true;
        cta.classList.add('is-loading');
        cta.disabled = true;
        var prevText = ctaText ? ctaText.textContent : '';
        if (ctaText) ctaText.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart/add ' + r.status);
          return r.json();
        }).then(function () { window.location.href = '/cart'; })
          .catch(function (err) {
            console.error('[Merch PDP] add-to-cart failed', err);
            cta.classList.remove('is-loading');
            cta.disabled = false;
            if (ctaText) ctaText.textContent = prevText;
            if (errEl) { errEl.textContent = "Couldn't add to your bag. Please try again."; errEl.hidden = false; }
          });
      });
    }

    onOptionChange();
  }

  function init() {
    document.querySelectorAll('.product-merch').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
